export default __webpack_public_path__ + "15d9f621c3bd1599f0169dcf0bd5e63e.woff2";